import { useEffect, useState } from 'react';
import { SITE } from '@/data';

const ITEMS = [
  'NEW EPISODES MONDAYS 6PM',
  `NEXT IN THE CAR · ${SITE.nextGuest}`,
  'EVERY TOP 10 · EVERY STORY'
];

/* Live countdown to the next drop, Europe/London wall clock */
function useNextDropCountdown() {
  const [txt, setTxt] = useState('');
  useEffect(() => {
    const tick = () => {
      const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' }));
      const target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), SITE.nextDrop.hour, 0, 0);
      let add = (SITE.nextDrop.day - target.getDay() + 7) % 7;
      if (add === 0 && target <= now) add = 7;
      target.setDate(target.getDate() + add);
      const diff = Math.max(0, target - now);
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      setTxt(
        `${String(d).padStart(2, '0')}D ${String(h).padStart(2, '0')}H ${String(m).padStart(2, '0')}M ${String(s).padStart(2, '0')}S`
      );
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);
  return txt;
}

function VinylDot() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" className="mx-2 shrink-0" aria-hidden="true">
      <circle cx="12" cy="12" r="10" fill="#211A1F" />
      <circle cx="12" cy="12" r="4.5" fill="#D3A6CF" />
      <circle cx="12" cy="12" r="1.4" fill="#211A1F" />
    </svg>
  );
}

export default function Marquee() {
  const countdown = useNextDropCountdown();
  return (
    <section aria-label="It's Funky Baby — what's on" data-testid="marquee-band" className="relative z-10 -my-2 overflow-hidden py-6">
      <div className="-ml-[2%] w-[104%] -rotate-1 bg-gold py-4 text-plum shadow-[0_18px_60px_rgba(232,184,106,0.18)]">
        <div className="flex w-max animate-marquee">
          {[0, 1].map((dup) => (
            <div key={dup} className="flex shrink-0 items-center" aria-hidden={dup === 1}>
              <span className="mx-2 flex items-center whitespace-nowrap rounded-full bg-plum px-5 py-2 font-mono text-lg font-bold tracking-widest text-gold md:text-xl" data-testid="marquee-countdown">
                <span className="h-2 w-2 animate-ping rounded-full bg-gold opacity-70" aria-hidden="true" />
                <span className="pl-3 tabular-nums">NEXT DROP · {countdown}</span>
                <VinylDot />
              </span>
              {ITEMS.map((t, i) => (
                <span key={i} className="flex items-center whitespace-nowrap font-display text-2xl tracking-wide md:text-3xl" data-testid="marquee-item">
                  <span className="px-7">{t}</span>
                  <VinylDot />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

